import React from 'react';
import clsx from "clsx";
import Svg from "../Svg";
import { translate } from "../../Services/translation";

/**
 *
 * @param {string} size
 * @param {string} extraClass
 * @returns {JSX.Element}
 * @constructor
 */
const ProductBundleIndicator = ({ size, extraClass }) => {
    return <div className="text-left">
        <div className={clsx('product-bundle-indicator', {
            [`size--${size}`]: size,
            extraClass
        })}>
            <Svg icon="box" /> <span>{translate('muha.bundledproducts.indicator.text')}</span>
        </div>
    </div>;
}
export default ProductBundleIndicator
